import WordbankList from './WordBankList';
import WordbankUpload from './WordBankUpload';

export default {
  displayNameKey: 'wordbank',
  icon: 'menu_wordbank',
  pages: {
    WordbankList,
    WordbankUpload,
  },
};



// WEBPACK FOOTER //
// ./src/modules/Wordbank/index.js